import api from 'api';

export const loadAnnotations = api('POST /api/tracker/chart/annotations');
export const loadAnnotationsByDates = api(
  'POST /api/tracker/chart/annotations/by-dates'
);

export const loadAnnotationTypes = api(
  'GET /api/tracker/chart/annotations/types'
);
export const loadAnnotationSubTypes = api(
  'GET /api/tracker/chart/annotations/subtypes'
);
export const loadChart = api('POST /api/tracker/chart');
export const exportChart = api('POST /api/tracker/chart/csv', {
  responseType: 'blob',
});
export const exportFromGoogleDriveChart = api(
  'POST /api/tracker/chart/export-to-google-drive'
);
